import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

export const fetchProducts = async (params = {}) => {
  const { data } = await api.get("/products", { params });
  return data;
};

export const fetchProduct = async (slug, params = {}) => {
  const { data } = await api.get(`/products/${slug}`, { params });
  return data;
};

export const fetchShopInfo = async () => {
  const { data } = await api.get("/shop/info");
  return data;
};

export const startShopifyCheckout = async (guestId, country) => {
  const { data } = await api.post("/shopify/checkout-from-cart", { guest_id: guestId, country });
  return data;
};

export const searchSuggest = async (q) => {
  const { data } = await api.get("/search/suggest", { params: { q } });
  return data;
};

export const getCart = async (guestId) => {
  const { data } = await api.get(`/cart/${guestId}`);
  return data;
};

export const upsertCart = async (payload) => {
  const { data } = await api.post("/cart", payload);
  return data;
};

export const quizRecommend = async (guestId, answers) => {
  const { data } = await api.post("/quiz/recommend", { guest_id: guestId, answers });
  return data;
};

export const createCheckoutSession = async (guestId) => {
  const { data } = await api.post("/checkout/session", { guest_id: guestId });
  return data;
};

export const confirmCheckout = async (payload) => {
  const { data } = await api.post("/checkout/confirm", payload);
  return data;
};

export const fetchOrder = async (orderId) => {
  const { data } = await api.get(`/orders/${orderId}`);
  return data;
};

export const fetchCurrencyRates = async () => {
  const { data } = await api.get("/currency/rates");
  return data;
};
